import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BodyLarge, ButtonLink, H3, DivWithShadowAlternate } from '@styled';

const Image = styled.img`
    height: 100%;
    object-fit: cover;
    width: 100%;
`;

const EmptyStateContainer = ({ Body, header, imageSrc, imageAlt, ctaText, ctaHref, onCTAClick }) => (
    <DivWithShadowAlternate>
        <div className="container">
            <div className="row">
                <div className="col-12 col-lg-8 px-0 text-center d-flex align-items-center justify-content-content">
                    <div className="p-1.875rem">
                        <H3 className="m-0">{header}</H3>
                        <BodyLarge className="mt-3">
                            <Body />
                        </BodyLarge>

                        <div className="mt-4">
                            <ButtonLink href={ctaHref} onClick={onCTAClick}>
                                {ctaText}
                            </ButtonLink>
                        </div>
                    </div>
                </div>

                {imageAlt && imageSrc && (
                    <div className="col-12 col-lg-4 bg-gray d-none d-md-block px-0">
                        <Image alt={imageAlt} src={imageSrc} />
                    </div>
                )}
            </div>
        </div>
    </DivWithShadowAlternate>
);

EmptyStateContainer.propTypes = {
    Body: PropTypes.elementType.isRequired,
    header: PropTypes.string.isRequired,
    imageSrc: PropTypes.string.isRequired,
    imageAlt: PropTypes.string,
    ctaText: PropTypes.string.isRequired,
    ctaHref: PropTypes.string,
    onCTAClick: PropTypes.func.isRequired,
};

export default EmptyStateContainer;
